// extracted by mini-css-extract-plugin
export default {"spinner":"RippleSpinner_spinner__zCOI7","animloader":"RippleSpinner_animloader__1dwtt"};